import { Action } from "@ngrx/store";
import { CompanyFilters } from "../../models/company.model";

export enum CompaniesActionTypes {
  SetFilters = "[Companies] Filters",
}

export class SetFilters implements Action {
  readonly type = CompaniesActionTypes.SetFilters;
  constructor(public payload: CompanyFilters) {}
}

export type CompaniesActions = | SetFilters;
